import { memo } from "react";
import { View } from "@src/components";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { PressableScale } from "pressto";

type ExitFullscreenButtonProps = {
  onPress: () => void;
};

export const ExitFullscreenButton = memo(({ onPress }: ExitFullscreenButtonProps) => {
  const { theme } = useUnistyles();

  return (
    <PressableScale onPress={onPress} style={styles.container} hitSlop={theme.spacing.md}>
      <View style={styles.button}>
        <Icon name="close" size={theme.spacing["6xl"]} color={theme.colors.mediaOverlay.foreground} />
      </View>
    </PressableScale>
  );
});

const styles = StyleSheet.create((theme) => ({
  container: {
    position: "absolute",
    top: theme.spacing.lg,
    left: theme.spacing.lg,
    zIndex: 10000,
  },
  button: {
    width: theme.spacing["8xl"],
    height: theme.spacing["8xl"],
    borderRadius: theme.spacing["2xl"],
    backgroundColor: theme.colors.mediaOverlay.backgroundMedium,
    alignItems: "center",
    justifyContent: "center",
  },
}));
